import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

export const MuiFormLabel: Components<Omit<Theme, 'components'>>['MuiFormLabel'] = {
  defaultProps: {
    style: {
      fontSize: 14,
    },
  },
  styleOverrides: {
    root: {
      '&.Mui-focused': {
        color: 'rgba(0,0,0,0.54)',
      },
    },
    asterisk: { color: palette.error.main },
  },
}
